// Kabinetlarda raqam va sanalarni ko'rsatish. Qiymat yo'q bo'lsa — "—".
export const DASH = '—';

const isEmpty = (value) => value === null || value === undefined || value === '' || Number.isNaN(value);

export function formatNumber(value) {
  if (isEmpty(value)) return DASH;
  const number = Number(value);
  if (!Number.isFinite(number)) return DASH;
  const [int, frac] = Math.abs(number).toFixed(Number.isInteger(number) ? 0 : 1).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${number < 0 ? '−' : ''}${grouped}${frac && frac !== '0' ? `,${frac}` : ''}`;
}

export function formatMoney(value, withUnit = true) {
  if (isEmpty(value)) return DASH;
  const text = formatNumber(Math.round(Number(value)));
  return text === DASH ? DASH : `${text}${withUnit ? " so'm" : ''}`;
}

// ratio: 0..1 → "71%"
export function formatPercent(ratio, digits = 0) {
  if (isEmpty(ratio)) return DASH;
  const number = Number(ratio) * 100;
  if (!Number.isFinite(number)) return DASH;
  return `${number.toFixed(digits).replace('.', ',')}%`;
}

export function formatDate(value) {
  if (!value) return DASH;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return DASH;
  return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;
}

export function formatDateTime(value) {
  if (!value) return DASH;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return DASH;
  return `${formatDate(value)} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

const MONTHS = ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun', 'iyul', 'avgust', 'sentabr', 'oktabr', 'noyabr', 'dekabr'];

// "2026-09" → "sentabr 2026"
export function formatMonthKey(key) {
  const match = /^(\d{4})-(\d{2})$/.exec(key || '');
  if (!match) return DASH;
  return `${MONTHS[Number(match[2]) - 1]} ${match[1]}`;
}

export const fullName = (person) =>
  [person?.first_name, person?.last_name].filter(Boolean).join(' ') || DASH;

// Trend foizini StatCard uchun yaxlitlash (20.734 → 20.7); qiymat yo'q bo'lsa undefined (ko'rsatilmaydi)
export function roundTrend(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const number = Number(value);
  return Number.isFinite(number) ? Math.round(number * 10) / 10 : undefined;
}

// Statistika kartalari uchun qisqa summa: 3 184 000 000 → "3,18 mlrd so'm", 412 000 000 → "412 mln so'm"
export function formatMoneyShort(value) {
  if (isEmpty(value)) return DASH;
  const number = Number(value);
  if (!Number.isFinite(number)) return DASH;
  const abs = Math.abs(number);
  if (abs >= 1e9) return `${(number / 1e9).toFixed(2).replace('.', ',').replace(/,?0+$/, '')} mlrd so'm`;
  if (abs >= 1e6) return `${(number / 1e6).toFixed(1).replace('.', ',').replace(/,0$/, '')} mln so'm`;
  return formatMoney(number);
}
